// Spotlight — portal entry (owned by the spotlight feature).
import { Megaphone } from "lucide-react";
import { RequireIgAccount } from "../../lib/igAccount";
import type { FeatureModule } from "../registry";

const spotlight: FeatureModule = {
  id: "spotlight",
  nav: [{ to: "/spotlight", label: "Spotlight", icon: Megaphone, group: "growth", order: 22 }],
  routes: [
    {
      path: "/spotlight",
      lazy: async () => {
        const { SpotlightPage } = await import("./SpotlightPage");
        return {
          Component: () => (
            <RequireIgAccount>
              <SpotlightPage />
            </RequireIgAccount>
          ),
        };
      },
    },
    {
      path: "/spotlight/new",
      lazy: async () => {
        const { BuilderPage } = await import("./BuilderPage");
        return {
          Component: () => (
            <RequireIgAccount>
              <BuilderPage />
            </RequireIgAccount>
          ),
        };
      },
    },
    {
      path: "/spotlight/:automationId",
      lazy: async () => {
        const { AutomationPage } = await import("./AutomationPage");
        return {
          Component: () => (
            <RequireIgAccount>
              <AutomationPage />
            </RequireIgAccount>
          ),
        };
      },
    },
    {
      path: "/spotlight/:automationId/edit",
      lazy: async () => {
        const { BuilderPage } = await import("./BuilderPage");
        return {
          Component: () => (
            <RequireIgAccount>
              <BuilderPage />
            </RequireIgAccount>
          ),
        };
      },
    },
  ],
};

export default spotlight;
